'use client';
import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { Button } from '@pickleballinc/react-ui';
import { useEffect, useState } from 'react';

import { publicEnv } from '@/lib/env';
import { getLoginUrl } from '@/utils/helpers/getLoginUrl';

export const BlurredResults = () => {
  const [baseURL, setBaseURL] = useState('');

  useEffect(() => {
    setBaseURL(window.location.href);
  }, []);

  return (
    <div className='relative'>
      <img
        src={getCDNURL(
          `${publicEnv.NEXT_PUBLIC_IMAGE_CDN_URL}/global/legacy/player_tournament_results_blur.png`,
          1012,
          568
        )}
        width={1012}
        height={568}
        alt='Events Placeholder'
      />
      <div className='absolute inset-0 flex items-center justify-center'>
        <a href={getLoginUrl(baseURL)} rel='nofollow' aria-label='Link to login or sign up'>
          <Button variant='primary' size='sm' className='bg-experiment'>
            Login or Sign Up
          </Button>
        </a>
      </div>
    </div>
  );
};
